import crm from './crm';
import subscriptionSettlementItem from './subscription-settlement-item';

export default {
  crm,
  subscriptionSettlementItem,
};
